import AvatarButton from '../AvatarButton';
import React, { memo, useCallback } from 'react';
import SettingsMenu from './SettingsMenu';
import EscapeListener from '../Utils/EscapeListener';
import TabAwayListener from '../Utils/TabAwayListener';

export default memo(function SettingsMenuWithButton({ uid = "settingsMenu", user }) {

    const [menuOpen, setMenuOpen] = React.useState(false);
    const menuButtonRef = React.useRef(null);
    const settingsMenuRef = React.useRef(null);
    const menuUid = uid;

    const handleMenuButtonClicked = useCallback(() => {
        console.log("handleMenuButtonClicked");
        setMenuOpen(!menuOpen)
    }, [setMenuOpen, menuOpen]);

    const handleEscapePressed = useCallback(() => {
        setMenuOpen(false);
        if(menuButtonRef.current) 
            menuButtonRef.current.focus();
    }, [setMenuOpen, menuButtonRef]);

    const handleClose = useCallback(() => setMenuOpen(false), [setMenuOpen]);

    return (
        <>
            <AvatarButton 
                user={user} 
                active={menuOpen}
                onClick={handleMenuButtonClicked}
                buttonRef={menuButtonRef}
            />
            <EscapeListener enabled={menuOpen} onKeyPress={handleEscapePressed}>
                <TabAwayListener tabRef={settingsMenuRef} enabled={menuOpen} tabAwayHandler={handleClose}>
                    <div ref={settingsMenuRef}>
                        <SettingsMenu uid={menuUid} open={menuOpen} onClose={handleClose} buttonRef={menuButtonRef} />
                    </div>
                </TabAwayListener>
            </EscapeListener>
        </>
    );
});